import * as React from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";

// Material UI
import { Paper } from "@material-ui/core";

// Layout
import { Col, Row } from "layout";

export interface CardProps extends React.Props<any> {
    widthToHeightRatio?: number;
    imageContainerId?: any;
    maxHeight?: number;
    maxWidth?: number;
    height?: number;
    width?: number;
}

function asCard<OriginalProps extends CardProps>(Component: React.ComponentType<OriginalProps & CardProps>) {
    @observer
    class Card extends React.Component<OriginalProps & CardProps> {
        @observable private widthToHeightRatio: number;
        @observable private height: number;
        @observable private width: number;

        constructor(props: any) {
            super(props);
        }

        componentWillReceiveProps(newProps: CardProps) {
            this.evaluateProps(newProps);
        }

        componentDidMount = () => {
            window.addEventListener("resize", () => {
                this.evaluateProps(this.props);
            });
            this.evaluateProps(this.props);
        };

        componentWillUnmount = () => {
            window.removeEventListener("resize", () => {
                this.evaluateProps(this.props);
            });
        };

        @action
        evaluateProps(props: CardProps) {
            // Default ratio
            if (!this.props.widthToHeightRatio) {
                this.widthToHeightRatio = 4 / 3;
            }

            // If containerRefId has been set, fit to container
            let domNode = document.getElementById(this.props.imageContainerId);
            let height = 0;
            let width = 0;
            if (domNode) {
                height = domNode.clientHeight;
                width = domNode.clientWidth * 0.98;
                if (height > 0 && width > 0) {
                    this.setContainerDimensions(width, height, props.maxHeight);
                }
            } else if (props.maxHeight || props.maxWidth) {
                height = props.maxHeight;
                width = props.maxWidth;
            } else if (props.height || props.width) {
                height = props.height;
                width = props.width;
            }
        }

        @action setContainerDimensions = (width: number, height: number, maxHeight: number) => {
            this.width = width;
            this.height = width / this.widthToHeightRatio;
            if (this.height > maxHeight) {
                this.height = height;
                this.width = height * this.widthToHeightRatio;
            }
        };

        render() {
            return (
                <Paper elevation={12} style={{ height: this.height, width: this.width }}>
                    <Col xs={12} style={{ height: "100%" }}>
                        <Row middle="xs" center="xs" style={{ height: "100%" }}>
                            <Component {...this.props} height={this.height} width={this.width} />
                        </Row>
                    </Col>
                </Paper>
            );
        }
    }

    return Card;
}

export default asCard;
